import Api from '../../api/Api'

const user = {
  //set namespace true
  namespaced: true,

  //state
  state: {},

  //mutations
  mutations: {},

  //actions
  actions: {
    list_user({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/user/user?jenis_kelamin=${data.jenis_kelamin}&id_pekerjaan=${data.id_pekerjaan}&id_provinsi=${data.id_provinsi}&page=${data.page}&per_page=${data.per_page}&role=${data.role}&kota=${data.id_kota}&status=${data.status}&search=${data.search}`,
        )
          .then((response) => {
            commit('')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_list_user({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.defaults.headers.common['Accept'] = 'application/octet-stream'
        Api.defaults.responseType = 'arraybuffer'
        Api.get(
          `/user/export_list_user?jenis_kelamin=${data.jenis_kelamin}&id_pekerjaan=${data.id_pekerjaan}&id_provinsi=${data.id_provinsi}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_admin() {
      return new Promise((resolve, reject) => {
        Api.defaults.headers.common['Accept'] = 'application/octet-stream'
        Api.defaults.responseType = 'arraybuffer'
        Api.get(`/user/export_admin`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    add_role_akses({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/user/add_akses`, data)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubah_role_akses({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/user/update_akses`, data)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    log_user({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/user/log_user?id_role=${data.id_role}&event=${data.event}&start=${data.start}&end=${data.end}`,
        )
          .then((response) => {
            commit('')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    log_admin({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/user/log_admin?id_role=${data.id_role}&event=${data.event}&start=${data.start}&end=${data.end}&page=${data.page}&per_page=${data.per_page}`,
        )
          .then((response) => {
            commit('')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    admin() {
      return new Promise((resolve, reject) => {
        Api.get(`/user/admin`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    reseller() {
      return new Promise((resolve, reject) => {
        Api.get(`/user/reseller`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getAksesRole({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/user/editAkses/${data.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    get_menu_role() {
      return new Promise((resolve, reject) => {
        Api.get(`/user/menu_role`)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_log_user({ commit }, data) {
      Api.defaults.headers.common['Accept'] = 'application/octet-stream'
      Api.defaults.responseType = 'arraybuffer'
      return new Promise((resolve, reject) => {
        Api.get(
          `/user/export_log_user?id_role=${data.id_role}&event=${data.event}&start=${data.start}&end=${data.end}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_log_admin({ commit }, data) {
      Api.defaults.headers.common['Accept'] = 'application/octet-stream'
      Api.defaults.responseType = 'arraybuffer'
      return new Promise((resolve, reject) => {
        Api.get(
          `/user/export_log_admin?id_role=${data.id_role}&event=${data.event}&start=${data.start}&end=${data.end}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    add_admin({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/user/add_admin`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_admin({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/user/update_admin/${data.id}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    delete_admin({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/user/delete_admin/${data.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    pekerjaan() {
      return new Promise((resolve, reject) => {
        Api.get(`/user/pekerjaan`)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detail_admin({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/user/getadmin/${data.id}`)
          .then((response) => {
            commit('')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {},
}

export default user
